import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import Layers from '@cover/fuehlenstarten/fuehlenstarten';

const FloatingItems = styled(Layers)`
	position: absolute;
	top: 0%;
`

const FuehlenStarten = ({ play }) => {
	const floatingItems = createRef();

	useEffect(() => {
		const stars = floatingItems.current.querySelector('#fuehlenstarten_svg__stars')
		const sunsWhite = floatingItems.current.querySelector('#fuehlenstarten_svg__white-suns')
		const bubbles = floatingItems.current.querySelector('#fuehlenstarten_svg__bubbles')
		const spiral = floatingItems.current.querySelector('#fuehlenstarten_svg__spiral-bottom-middle')
		const eye = floatingItems.current.querySelector('#fuehlenstarten_svg__eye-top-right')
		const tear = floatingItems.current.querySelector('#fuehlenstarten_svg__tear-top-right')
		const head = floatingItems.current.querySelector('#fuehlenstarten_svg__head-bottom-left')
		const starYellowTop = floatingItems.current.querySelector('#fuehlenstarten_svg__sun-top-left')
		const starYellowBottomLeft = floatingItems.current.querySelector('#fuehlenstarten_svg__yellow-sun-middle-left')
		const starYellowBottomRight = floatingItems.current.querySelector('#fuehlenstarten_svg__yellow-sun-bottom-right')
		const flowerTop = floatingItems.current.querySelector('#fuehlenstarten_svg__flower-top-left')
		const flowersCenter = floatingItems.current.querySelector('#fuehlenstarten_svg__flowers-middle')
		const circlesYellow = floatingItems.current.querySelector('#fuehlenstarten_svg__circles-middle-right')
		const dotsTop = floatingItems.current.querySelector('#fuehlenstarten_svg__five-dots-top')
		const sunGeenCenter = floatingItems.current.querySelector('#fuehlenstarten_svg__green-sun-middle')
		const sunGreenTop = floatingItems.current.querySelector('#fuehlenstarten_svg__green-sun-top-middle')
		const sunBlueBottom = floatingItems.current.querySelector('#fuehlenstarten_svg__blue-sun-bottom-right')
		const sunBlueTop = floatingItems.current.querySelector('#fuehlenstarten_svg__blue-sun-top-right')
		const heart = floatingItems.current.querySelector('#fuehlenstarten_svg__heart-bottom-right')

		anime({
			targets: stars,
			autoplay: play,
			loop: true,
			easing: 'easeInSine',
			duration: 4500,
			keyframes: [
				{opacity: .3},
				{opacity: 1}
			]
		})
		anime({
			targets: sunsWhite,
			autoplay: play,
			loop: true,
			easing: 'easeInSine',
			duration: 3000,
			keyframes: [
				{opacity: .7},
				{opacity: 1}
			]
		})
		anime({
			targets: [sunBlueTop, sunGeenCenter, sunGreenTop, starYellowBottomLeft, sunBlueBottom, starYellowBottomRight, starYellowTop],
			autoplay: play,
			loop: true,
			easing: 'easeInSine',
			duration: 5000,
			delay: anime.stagger(400),
			keyframes: [
				{opacity: .7},
				{opacity: 1}
			]
		})
		anime({
			targets: circlesYellow,
			autoplay: play,
			duration: 7000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: -16, translateX: 0},
				{translateY: -18, translateX: 17},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: spiral,
			autoplay: play,
			duration: 4500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: -13, translateX: 12},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: [eye, tear],
			autoplay: play,
			duration: 5500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: -14, translateX: 19, rotate: 0},
				{translateY: 0, translateX: 0, rotate: 0}
			]
		});
		anime({
			targets: [starYellowBottomRight, sunGreenTop],
			autoplay: play,
			duration: 5500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: 18, translateX: -19, rotate: 0},
				{translateY: 0, translateX: 0, rotate: 0}
			]
		});
		anime({
			targets: heart,
			autoplay: play,
			duration: 4000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: 0, translateX: -16},
				{translateY: 12, translateX: -10},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: starYellowTop,
			autoplay: play,
			duration: 5000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: 0, translateX: -16},
				{translateY: 12, translateX: -10},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: head,
			autoplay: play,
			duration: 5000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: -9, translateX: -8},
				{translateY: -14, translateX: 6},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: flowerTop,
			autoplay: play,
			duration: 8000,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: 16, translateX: -18},
				{translateY: -14, translateX: 12},
				{translateY: 0, translateX: 0}
			]
		});
		anime({
			targets: bubbles,
			autoplay: play,
			duration: 4500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: -13, translateX: 9},
				{translateY: 0, translateX: 14},
				{translateY: 0, translateX: 0}
			]
		});
	}, [play])
	return (
		<>
			<FloatingItems ref={floatingItems}/>
		</>
	)
};

export default FuehlenStarten;